<template>
  <b-modal :id="`modal-new-rule`" title="Nova Regra" size="xl">
    <new-alert-rule :actionId="actionId" />
    <template v-slot:modal-footer>
      <div>
        <button class="btn btn-secondary" @click="hideModal">
          {{ $t('newAction.stepOne.cancelButton') }}
        </button>
        <button
          class="btn btn-primary"
          v-if="alertRulesFooter"
          @click="saveRule"
        >
          {{ $t('newAction.stepOne.saveButton') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import NewAlertRule from '@/components/organisms/settings/settings-alert-rules/new-rule';
import EventBus from '../../../eventBus';

export default {
  components: {
    NewAlertRule,
  },

  computed: {
    ...mapState('settings', ['alertRulesFooter']),
    ...mapFields('alertRules', ['newRule']),
  },

  props: ['actionId'],
  data: () => ({
    userAuth: null,
  }),
  methods: {
    hideModal() {
      this.$bvModal.hide('modal-new-rule');
    },
    saveRule(event) {
      EventBus.$emit('registerNewRule', event);
    },
  },
  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  created() {
    this.newRule = {
      name: null,
      rules: [
        {
          email: null,
          justComment: false,
          alerts: [
            { grade: 0, value: false },
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
            { grade: 6, value: false },
            { grade: 7, value: false },
            { grade: 8, value: false },
            { grade: 9, value: false },
            { grade: 10, value: false },
          ],
        },
      ],
      level1: {
        email: null,
        days: null,
      },
      level2: {
        email: null,
        days: null,
      },
      level3: {
        email: null,
        days: null,
      },
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/modal-new-rule/index.vue